let cached = null;

export const getConfig = async () => {
  if (cached) return cached;
  try {
    const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/config`);
    cached = await r.json();
  } catch {
    cached = { checkout_enabled: false };
  }
  return cached;
};
